import Cookies from 'js-cookie'
import localStore from 'src/utils/local-storage'
import * as type from '../constants/AuthActionTypes'
import StorageService from '../../services/StorageService';
import {
  CONSTS
} from '../../config/Constant';

const initialState = {
  error: '',
  userInfo: StorageService.get(CONSTS.STORE_KEYS.USER.PROFILE) || {
    id: 0
  },
  accesstoken: '',
  loaded: false,
  statusLogin: 0,
  loggedOut: false
};

export default function reducer(state = initialState, action = {}) {
  let {
    value
  } = action
  switch (action.type) {

    case type.LOGIN:
      return {
        ...state,
        statusLogin: 1
      }

      case type.LOGIN_SUCCESS:
        setToken(action.result);
        return {
          ...state,
          userInfo: action.result.user,
            statusLogin: 2,
            accesstoken: action.result.jwt
        }

        case type.LOGIN_FAIL:
          return {
            ...state,
            error: action.error,
              statusLogin: 3
          }

          case type.SIGN_OUT:
            unSetToken();
            return {
              ...state,
              userInfo: null,
                statusLogin: 0,
                accesstoken: '',
                loggedOut: true
            }

            case type.SET_USER_INFO:
              return {
                ...state,
                userInfo: value,
              }

              case type.CHECK_ACCESSTOKEN:
                return {
                  ...state,
                }
                case type.CHECK_ACCESSTOKEN_SUCCESS:
                  localStore.set('_user', action.result);
                  return {
                    ...state,
                    userInfo: action.result
                  }
                  case type.CHECK_ACCESSTOKEN_FAIL:
                    localStore.remove('_user');
                    return {
                      ...state,
                      error: action.error,
                    }
                    case type.LOADING:
                      value = typeof value === 'undefined' ? false : value
                      return {
                        ...state,
                        loaded: (value ? true : false)
                      }
                      default:
                        return state
  }
}

export const setToken = token => {
  if (!process.browser) {
    return;
  }
  const user = token.user;
  // if(user.categories && user.categories.length > 0){
  //   user.categories[0].selected = true;
  // }
  Cookies.set("jwt", token.jwt, {
    expires: 1
  });
  Cookies.set("user_id", user.id, {
    expires: 1
  });
  localStore.set('_user', user);
};


export const unSetToken = () => {
  if (!process.browser) {
    return;
  }
  Cookies.remove("jwt");
  Cookies.remove("user_id");
  localStore.remove('_user');
  StorageService.delete(CONSTS.STORE_KEYS.USER.PROFILE)
  StorageService.delete(CONSTS.STORE_KEYS.USER.TOKEN)
  window.location.href = '/login';
};